<template>
  <div
    v-if="isDeveloper && isProduction"
    class="fixed inset-0 z-50 pointer-events-none border-3 border-solid border-critical-500"
  >
    <AwBadge
      :label="$t('common.environment.production')"
      color="critical"
      variant="solid"
      size="sm"
      leading-icon="i-ph-warning-fill"
      class="absolute top-0 left-1/2 -translate-x-1/2 rounded-t-none"
    />
  </div>
</template>

<script setup lang="ts">
import { AwBadge } from "@asap/design";
import { useUserMe } from "~/components/user/composables/useUser";
import { useEnvironment } from "~/composables/useEnvironment";

const { isDeveloper } = useUserMe();
const { isProduction } = useEnvironment();
</script>
